import { OverviewState, useOverviewLinkState } from '../linkstate/financialOverview.linkstate';

export const useOverviewLinkStateActions = () => {
    const [state, setState] = useOverviewLinkState();
    return {
        patch: (patch: Partial<OverviewState>) => setState({ ...state, ...patch }),
    };
};
